import React, { useEffect, useState, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import dayjs from "dayjs";
import html2pdf from "html2pdf.js";
import commonLabels from "../../common/labels/common_en.json";
import PhysicalTestApprovalEntity from "./PhysicalTestApprovalEntity";
import TablePagination from "../../common/components/TablePagination";
import label from "../../postExaminationProcessObjective/labels/postExaminationProcessObjective_en.json";
import { getPhysicalTestMarks, physicalTestMarksApprovalRequest, getAllApprovalPhysicalTestMarksPagination } from "../actions/testsActions";
import { getExamslistByAdvertisementId } from "../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import { getYearList, getMainsAdvertisements } from "../../common/actions/commonActions";
import labels from "../labels/tests_en.json";
import ImportPhysicalTestMarks from "./ImportPhysicalTestMarks";

let headerField = [
  {
    id: "1",
    steps: "Step 1",
    name: "Approvals",
  },
  {
    id: "2",
    steps: "Step 2",
    name: "Physical Test",
  }
];

const PhysicalTest = () => {

  const pdfRef = useRef(null);

  let unapprovalEntityHeader = [
    "No.",
    "Action",
    "Status",
    "Updated On",
    "Exam Name",
    // "Subject Name",
    "Entity Type",
    "Approval Type",
    "Approver",
    "Comments By Approver",
    "Action",
  ];

  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
  });

  let {
    getAnswerKeyData,
    allUnapprovalEntityList,
    unapprovalPageNoCounter,
    examList
  } = useSelector((state) => state.postExamProcessObjectReducer, shallowEqual);

  let { yearList, getMainsAdvertisement } = useSelector(
    (state) => state.common,
    shallowEqual
  );

  let { physicalTestData } = useSelector(
    (state) => state.testsReducer,
    shallowEqual
  );

  let tableCounter_unapproval = unapprovalPageNoCounter + 1;
  let rowPerPage = 10;

  const [selectedAdvertNo, setSelectedAdvertNo] = useState("");
  const [selectedExam, setSelectedExam] = useState("");
  const [reloadItem, setReloadItem] = useState(true);
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const session = JSON.parse(sessionStorage.getItem("session"));
  const [editedValues, setEditedValues] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [stepName, setName] = useState("2");
  const [selectedYear, setSelectedYear] = useState("");
  let [selectedApprovalEntity, setSelectedApprovalEntity] = useState("");
  let [approvalEntityModal, setApprovalEntityModal] = useState(false);
  let [listCurrentPage, setListCurrentPage] = useState(0);
  const [showImportMarks, setShowImportMarks] = useState(false);
  const [physicalMarksData, setPhysicalMarksData] = useState([]);


  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(getYearList());
    onCancelButton();
    setReloadItem(!reloadItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (stepName === "1") {
      dispatch(
        getAllApprovalPhysicalTestMarksPagination(listCurrentPage, rowPerPage)
      );
    }
  }, [stepName, listCurrentPage, rowPerPage, dispatch]);

  useEffect(() => {
    onCancelButton();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepName]);

  useEffect(() => {
    if (physicalTestData) {
      setPhysicalMarksData(physicalTestData.medicalAndPhysicalTestDtos);
    }
  }, [physicalTestData]);

  const formData = Object.keys(editedValues).map(key => {
    const item = editedValues[key];
    return {
      hallticketNo: key,
      mark: item.mark
    };
  });

  const onSelectYear = (ele) => {
    if (ele == "") {
      onCancelButton()
    } else {
      let selectedValue = ele;
      setSelectedYear(selectedValue);
      selectedValue && dispatch(getMainsAdvertisements(selectedValue));
      if (getMainsAdvertisement) {
        getMainsAdvertisement.length = 0
      }
      physicalTestData.length = 0;
      setSaveButtonFlag(true);

      setReloadItem(!reloadItem);
    }

  };

  const onAdvertisementChange = (ele) => {
    let selectedValue = ele;
    setSelectedAdvertNo(selectedValue);
    setSaveButtonFlag(true);
    selectedValue && dispatch(getExamslistByAdvertisementId(selectedValue));
    physicalTestData.length = 0;
    examList.length = 0;
    setSelectedExam("");
    setReloadItem(!reloadItem);
    setEditMode(true);
  };

  const onExamChange = (ele) => {
    let selectedValue = ele;
    setSelectedExam(selectedValue);
    setEditMode(false);
    setSaveButtonFlag(false);
    selectedValue && dispatch(getPhysicalTestMarks(selectedValue));
    setReloadItem(!reloadItem);
  };

  const onCancelButton = () => {
    setSelectedAdvertNo("");
    setSelectedYear("");
    setSaveButtonFlag(true);
    setReloadItem(!reloadItem);
    if (getMainsAdvertisement) {
      getMainsAdvertisement.length = 0;
    }
    physicalTestData.length = 0;
    examList.length = 0;
    setSelectedExam("");
    setEditedValues({});
    setEditMode(false);
    setPhysicalMarksData([]);
  };

  const onSubmit = () => {
    setReloadItem(!reloadItem);
  };

  const genPdf = () => {
    let headerDiv = '<div class="row d-flex flex-column align-items-center"><h5>' + commonLabels.MPSC + '</h5><h5>' + physicalTestData.examName + '</h5><h5>' + labels.PhysicalTest + '</h5></div>';
    const htmlContent = document.createElement("div");
    htmlContent.innerHTML = headerDiv;
    htmlContent.innerHTML += pdfRef.current.innerHTML;

    const options = {
      margin: [1, 0.4, 0.7, 0.4],
      filename: "PhysicalTestMarks.pdf",
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 2, dpi: 300, letterRendering: true },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
        compressPDF: true,
      },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth =
            (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1.2;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }).split('/').join('/');

          const dateWidth = pdf.getStringUnitWidth(formattedDate) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth - 0.4;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, dateX, textY)

          const ad = physicalTestData.advertisementNo;
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);
        }

        pdf.save(`PhysicalTestMarks.pdf`);
      });
  };

  const downloadPdf = () => {
    genPdf();
    setReloadItem(!reloadItem);
  };

  const handleEditButtonClick = () => {
    setEditMode(true);
  };

  const handleConfirmButtonClick = () => {

    formData.length !== 0 && dispatch(physicalTestMarksApprovalRequest(selectedExam, formData));
    onCancelButton();
    setEditMode(false);

  };

  const handleInputChange = (hallticketNo, value) => {
    setEditedValues({
      ...editedValues,
      [hallticketNo]: {
        ...editedValues[hallticketNo],
        mark: value
      }
    });
  };

  const handleApprovalUser = (ele) => {
    setSelectedApprovalEntity(ele);
    setApprovalEntityModal(true);
  };

  return (
    <div className="dashboardContentArea">
      <h5 className="ml-3"> {labels.PhysicalTest} </h5>
      <div
        className="tab-content border border-light myTabContent"
        id="myTabContentContainer"
      >
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          {headerField &&
            headerField.map((ele, index) => (
              <li className="nav-item" key={ele.id}>
                <a
                  href="#"
                  className={
                    stepName === ele.id
                      ? "nav-link active"
                      : "nav-link bg-profile-tabs"
                  }
                  value="home"
                  id="home-tab"
                  onClick={() => setName(ele.id)}
                  data-toggle="tab"
                  role="tab"
                  aria-controls="home"
                  aria-selected="false"
                >
                  <span>{ele.name}</span>
                </a>
              </li>
            ))}
          <div className="ml-auto">
            <button
              type="reset"
              className="btn btn-primary import-button"
              onClick={() => setShowImportMarks(true)}
            >
              {commonLabels.BUTTON_IMPORT_MARKS}
            </button>
          </div>
        </ul>
        <div className="tab-content border border-light" id="myTabContent">
          <div
            className={
              stepName === "1"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            {allUnapprovalEntityList &&
              allUnapprovalEntityList.entityApprovalDtoList &&
              allUnapprovalEntityList.entityApprovalDtoList.length > 0 ? (
              <>
                <table className="table table-bordered">
                  <thead className="thead-light">
                    <tr>
                      {unapprovalEntityHeader &&
                        unapprovalEntityHeader.map((itm, ind) => (
                          <th key={ind}
                            className={`${itm === "No." || itm === "Action"
                              ? "text-center"
                              : ""
                              }`}>
                            {itm}
                          </th>
                        ))}
                    </tr>
                  </thead>
                  <tbody>
                    {allUnapprovalEntityList &&
                      allUnapprovalEntityList.entityApprovalDtoList &&
                      allUnapprovalEntityList.entityApprovalDtoList.length >
                      0 &&
                      allUnapprovalEntityList.entityApprovalDtoList.map(
                        (ele, index) => {
                          return (
                            <tr key={index}>
                              <td className="w-5 text-center">
                                {tableCounter_unapproval++}
                              </td>
                              <td className="word-break">
                                {ele.entityApprovalAction.actionLabel}
                              </td>
                              <td className=" width-5">
                                {ele.entityApprovalAction.level == 1
                                  ? label.APPROVAL_LEVEL_1_PENDING
                                  : ""}
                                {ele.entityApprovalAction.level == 2
                                  ? label.APPROVAL_LEVEL_2_PENDING
                                  : ""}
                                {ele.entityApprovalAction.level == 3
                                  ? label.APPROVAL_LEVEL_3_PENDING
                                  : ""}
                              </td>
                              <td className=" word-break width-10">
                                {ele.entityApprovalAction.updatedAt
                                  ? dayjs(
                                    ele.entityApprovalAction.updatedAt
                                  ).format("DD/MM/YYYY h:mm A")
                                  : ""}
                              </td>

                              <td className="w-10 word-break  width-20">
                                {ele.entityApprovalAction.entityApprovalDto
                                  .detail &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.examName}{" "}
                                <br />{" "}

                              </td>
                              {/* <td className="text-centerw-10 word-break  text-center width-12">
                                {ele.entityApprovalAction.entityApprovalDto
                                  .detail &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.subject &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.subject.name}{" "}
                                <br />{" "}
                                {ele.entityApprovalAction.entityApprovalDto
                                  .detail &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.subject &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.subject.nameDvng}
                              </td> */}
                              <td >
                                {ele.entityApprovalAction.entityApprovalDto.entityMaster.name.replace(
                                  "_",
                                  " "
                                )}
                              </td>

                              <td className=" word-break">
                                {
                                  ele.entityApprovalAction.entityApprovalDto
                                    .approvalTypeLabel
                                }
                              </td>
                              <td className=" word-break">
                                {
                                  ele.entityApprovalAction.entityApprovalDto
                                    .approvalByUser.firstName
                                }{" "}
                                {
                                  ele.entityApprovalAction.entityApprovalDto
                                    .approvalByUser.lastName
                                }
                              </td>

                              <td className=" word-break width-10">
                                {ele.entityApprovalAction.comments}
                              </td>
                              <td className="text-center word-break width-20">
                                {(session.roleName == 'superadmin' || session.roleName == 'desk officer') &&
                                  <button
                                    type="button"
                                    className="mx-auto btn btn-outline-primary btn-sm custom-button"
                                    onClick={() => {
                                      handleApprovalUser(ele);
                                    }}
                                  >
                                    {label.REVIEW}
                                  </button>}
                              </td>
                            </tr>
                          );
                        }
                      )}
                  </tbody>
                </table>
                <TablePagination
                  paginationFor="un_answerkey_list"
                  rowPerPage={rowPerPage}
                  setListCurrentPage={setListCurrentPage}
                  totalCount={allUnapprovalEntityList.totalNoOfRecords}
                />
              </>
            ) : (
              <div className="text-center">
                <font className="text-danger">
                  {commonLabels.NO_DATA_FOUND}
                </font>
              </div>
            )}
          </div>

          <div
            className={
              stepName === "2"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12 ">
                <form name="importForm" encType="multipart/form-data">
                  <div className="form-group">
                    <div className="row">
                      <div className="form-group col-md-2">
                        <label className="float-left">
                          {commonLabels.selectYear}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedYear"
                          value={selectedYear}
                          // ref={register({ required: true })}
                          onChange={(e) => {
                            onSelectYear(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {yearList &&
                            yearList.length > 0 &&
                            yearList
                              .map((element, index) => (
                                <option key={index}>{element}</option>
                                // <option key={index} value={element.id}>
                                //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                // </option>
                              ))}
                        </select>
                        {_.get("selectedYear.type", errors) ===
                          "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                      </div>
                      <div className="form-group col-md-5">
                        <label className="float-left">
                          {commonLabels.SelectAdvertNo}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedAdvertiseNo"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onAdvertisementChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {getMainsAdvertisement &&
                            getMainsAdvertisement.length > 0 &&
                            getMainsAdvertisement
                              .filter(
                                (element) =>
                                  element.isDeleted == false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedAdvertiseNo.type", errors) ===
                          "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                      </div>

                      <div className=" col-md-4">
                        <label className="float-left">
                          {label.SelectExam}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedExam"
                          // value={selectedExam}
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onExamChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {
                            examList &&
                            examList.length > 0 &&
                            examList
                              .filter(
                                (element) =>
                                  element.isDeleted == false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {element.name}
                                </option>
                              ))
                          }
                        </select>
                        {_.get("selectedExam.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>

                    </div>

                    <div className="row">
                      <div className="form-group col-md-8">
                        <button
                          type="reset"
                          className="btn btn-secondary mr-2"
                          onClick={() => onCancelButton()}
                        >
                          {commonLabels.BUTTON_CANCEL}
                        </button>

                        <button
                          type="button"
                          className="btn btn-primary mr-2"
                          disabled={!physicalTestData.medicalAndPhysicalTestDtos || physicalTestData.medicalAndPhysicalTestDtos === 0 || saveButtonFlag || editMode}
                          onClick={handleEditButtonClick}
                        >
                          {commonLabels.BUTTON_EDIT}
                        </button>

                        <button
                          type="button"
                          className="btn btn-primary mr-2"
                          disabled={saveButtonFlag || !editMode}
                          onClick={handleConfirmButtonClick}
                        >
                          {commonLabels.BUTTON_CONFIRM}
                        </button>

                        {(session.roleName == 'superadmin' || session.roleName == 'secretary') &&
                          <button
                            type="button"
                            className="btn btn-primary mr-2"
                            disabled={!physicalTestData.medicalAndPhysicalTestDtos || physicalTestData.medicalAndPhysicalTestDtos === 0 || saveButtonFlag || editMode}
                            onClick={() => {
                              downloadPdf();
                            }}
                          >
                            {commonLabels.BUTTON_PRINT}
                          </button>}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            {selectedExam && physicalMarksData && physicalMarksData.length > 0 && (
              <div ref={pdfRef} className="answerKeyTable">

                <table className="table table-bordered text-center">
                  <thead className="thead-light bold-label">
                    <tr>
                      <th>Hall Ticket No</th>
                      <th>Marks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {physicalMarksData.map((ele, index) => (
                      <tr key={index}>
                        <td>{ele.hallticketNo}</td>
                        <td>
                          {editMode ? (
                            <input
                              type="text"
                              defaultValue={ele.mark}
                              value={editedValues[ele.hallticketNo]?.mark}
                              onChange={(e) => { handleInputChange(ele.hallticketNo, e.target.value) }}
                              className={editMode ? "editable-input-box" : "input-box"}
                              onKeyPress={e => {
                                if (!/[0-9]/.test(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              maxLength="3"
                            />
                          ) : (
                            ele.mark
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

              </div>
            )}
          </div>

          {approvalEntityModal && (
            <PhysicalTestApprovalEntity
              showModal={approvalEntityModal}
              setShowModal={setApprovalEntityModal}
              setSelectedApprovalEntity={selectedApprovalEntity}
            />
          )}
          <ImportPhysicalTestMarks
            showImportMarks={showImportMarks}
            setShowImportMarks={setShowImportMarks}
            onCancelButton={onCancelButton}
          />
        </div>
      </div>
    </div>
  );
};

export default PhysicalTest;
